// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import MyWishLists from '../components/MyWishLists/MyWishLists';
import { actions } from '../duck';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    isFetchingWishLists: state.myWishLists.isFetchingWishLists,
    wishLists: state.myWishLists.wishLists,
    fetchWishListsError: state.myWishLists.fetchWishListsError,
    page: state.myWishLists.wishListsPage,
    canAsk: state.myWishLists.wishListsPageCanAsk,
    postWishListError: state.myWishLists.postWishListError,
    isPostingWishList: state.myWishLists.isPostingWishList,
    postWishListSuccess: state.myWishLists.postWishListSuccess,
    putWishListError: state.myWishLists.putWishListError,
    isPuttingWishList: state.myWishLists.isPuttingWishList,
    putWishListSuccess: state.myWishLists.putWishListSuccess,
    deleteWishListError: state.myWishLists.deleteWishListError,
    isDeletingWishList: state.myWishLists.isDeletingWishList,
    deleteWishListSuccess: state.myWishLists.deleteWishListSuccess,
    localeState: state.locale,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...actions,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MyWishLists);



// WEBPACK FOOTER //
// ./src/modules/my-wish-lists/containers/MyWishListsContainer.jsx